define('shared/initializer/form/adapters/mixins/AdyenPayable',[
    '$',
    'shared/page/wcmmode',
    'shared/util/state',
    'shared/remote/payment/adyen/initSession',
    'shared/util/adyen/rejectWithOrderCreationFailed',
    'shared/remote/order/get',
    'shared/util/adyen/storage',
    'shared/lib/URI',
    'shared/util/state/adapters/order',
    'shared/initializer/form/constants',
    'Promise',
    'kernel/ui/Blocker',
    './AdyenSwitchable',
    'shared/util/adyen/rejectPayment',
    'shared/util/adyen/hideStoreDetailsTickboxes',
    'shared/util/adyen/addScript',
    'shared/util/adyen/getSDKConfig'
],
    function (
        $,
        getWCMMode,
        state,
        initPaymentSession,
        rejectWithOrderCreationFailed,
        getOrder,
        storage,
        URI,
        orderAdapter,
        constants,
        Promise,
        Blocker,
        AdyenSwitchable,
        rejectPayment,
        hideStoreDetailsTickboxes,
        addScript,
        getAdyenSDKConfig
    ) {
        'use strict';

        //define constants
        var idCount = 0;
        var PAYMENT_AUTHORISED = 'authorised';
        var PAYMENT_RECEIVED = 'received';
        var ORDERED = 'Ordered';
        var NEW = 'New';
        var PENDING = 'Pending';
        var ORDER_QUERY_COUNT = 20;
        var ORDER_QUERY_INTERVAL_MS = 3000;
        var ADYEN_MODULE_NAME = 'adyen-payment-form::';

        var uri = new URI(location.href);
        var searchParameters = uri.query(true);

        function initPaymentFlow(form) {
            var offers;
            var subEls = AdyenSwitchable.getSubElements(form);
            return addScript()
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                return state.retrieve(constants.State.OrderOfferId);
            })
            .then(function(value){
                offers = value;
                if (!offers || offers.length <= 0) {
                    return Promise.reject('No offer id specified');
                }
            })
            .then (function () {
                return initPaymentSession(offers);
            })
            .then(function (res) {
                console.log(ADYEN_MODULE_NAME, 'Payment form initialized');
                try {
                    var paymentSession = JSON.parse(res.extraInfo.http_redirect_parameters);
                } catch (err) {
                    console.log(ADYEN_MODULE_NAME, 'Failed to obtain paymentSession', err);
                }

                return {
                    paymentSession: paymentSession,
                    orderId: res.orderId
                };
            })
            .then(function (context) {
                return getAdyenSDKConfig()
                    .then(function(config){
                        context.sdkConfigObj = config;
                        return context;
                    });
            })
            .then(function(context){
                var chckt = window.chckt;
                var paymentSession = context.paymentSession;
                var sdkConfigObj = context.sdkConfigObj;
                var orderId = context.orderId;
                var $adyen = subEls.newPayment.$adyenContainer;
                var tmpId = 'adyen-wrapper-' + idCount++;

                storage.storeOrderId(orderId);
                $adyen.attr('id', tmpId);
                // Initiate the Checkout form.
                chckt.checkout(paymentSession, '#' + tmpId, sdkConfigObj);

                // we will always store user's credit card details
                // so here we will have to make it always ticked
                hideStoreDetailsTickboxes(form.$form);

                chckt.hooks.beforeComplete = function (node, paymentData) {
                    form._resultCode = paymentData.resultCode;
                    form.emit('payment.start');
                    // Indicates that you want to replace the default handling.
                    return false;
                };
            })
            .then(null, function (err) {
                return Promise.reject(err);
            });
        }

        function Ctor() {
            /* 
                was told the spinner need to cover the whole page as sometime sofort
            */
            this.docBlocker = new Blocker(document.body);
        }

        Ctor.prototype.doError = function() {
            return initPaymentFlow(this);
        };

        Ctor.prototype.doPageLoad = function() {
            var me = this;
            return getWCMMode()
                .then(function(wcmmmode){
                    if (wcmmmode !== 'disabled') {
                        return;
                    }
                    
                    if (searchParameters.resultCode) {
                        me._resultCode = searchParameters.resultCode;
                        me.emit('payment.start');
                        return;
                    }
                    
                    return initPaymentFlow(me);
                });
        };

        Ctor.prototype.doSubmit = function() {
            var form = this;
            var orderId = storage.retrieveOrderId();
            var orderInfo;
            var orderStatus;
            var count = 0;

            function makeSureOrderIsOrdered() {
                return getOrder({
                    id: orderId,
                    cache: {
                        bypass: true
                    }
                })
                    .then(function(result){
                        orderInfo = result;
                        orderStatus = orderInfo.Status;

                        if (orderInfo.Id) {
                            return state.adapters.add(orderAdapter)
                                .then(function() {
                                    return state.push('order.order_id', orderInfo.Id);
                                });
                        }
                    })
                    .then(function(){
                        if (orderStatus === ORDERED) {
                            return;
                        }
                        
                        if (
                            (
                                orderStatus === NEW ||
                                orderStatus === PENDING
                            ) && 
                            count < ORDER_QUERY_COUNT
                        ) {
                            count++;
                            return new Promise(function(rs){
                                setTimeout(rs, ORDER_QUERY_INTERVAL_MS);
                            })
                                .then(function(){
                                    return makeSureOrderIsOrdered();
                                });
                        }
                        
                        return rejectWithOrderCreationFailed();
                    }, function(){
                        return rejectWithOrderCreationFailed();
                    });
            }

            
            return Promise.resolve()
                .then(function(){
                    form.docBlocker.block();
                    if (
                        form._resultCode.toLowerCase() === PAYMENT_AUTHORISED || 
                        form._resultCode.toLowerCase() === PAYMENT_RECEIVED
                    ) {
                        return;
                    } 
                    
                    return rejectPayment();
                })
                .then(function(){
                    return makeSureOrderIsOrdered();
                })
                .then(function () {
                    storage.deleteOrderId();
                    return orderInfo;
                }, function(err) {
                    storage.deleteOrderId();
                    form.docBlocker.resume();
                    return Promise.reject(err);
                });
        };
    
        return Ctor;
        
    });
